import { render, staticRenderFns } from "./DecisionDiamondRule.vue?vue&type=template&id=a70aa3d6&scoped=true"
import script from "./DecisionDiamondRule.vue?vue&type=script&lang=js"
export * from "./DecisionDiamondRule.vue?vue&type=script&lang=js"
import style0 from "./DecisionDiamondRule.vue?vue&type=style&index=0&id=a70aa3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70aa3d6",
  null
  
)

export default component.exports